module.exports = __webpack_public_path__ + "media/images/lb/113-0c2cbddff4a5f4cac13306da9a203538.svg";